import _defineProperty from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';

var FormikWrapper = function FormikWrapper(props) {
  var initialValues = props.initialValues,
      onSubmit = props.onSubmit,
      displayRequiredIndicator = props.displayRequiredIndicator,
      validate = props.validate,
      validateOnChange = props.validateOnChange,
      validateOnBlur = props.validateOnBlur,
      validateOnMount = props.validateOnMount,
      onReset = props.onReset,
      restProps = _objectWithoutProperties(props, ["initialValues", "onSubmit", "displayRequiredIndicator", "validate", "validateOnChange", "validateOnBlur", "validateOnMount", "onReset"]);

  return /*#__PURE__*/React.createElement(Formik, _extends({
    initialValues: initialValues || {},
    onSubmit: onSubmit,
    validate: validate,
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onReset: onReset
  }, restProps), function (childProps) {
    return /*#__PURE__*/React.createElement(Form, null, React.Children.map(props.children, function (child) {
      var _child$props = child.props,
          fieldName = _child$props.fieldName,
          type = _child$props.type,
          htmlType = _child$props.htmlType,
          children = _child$props.children;

      if (type === 'submit' || htmlType === 'submit') {
        return /*#__PURE__*/React.cloneElement(child, {
          disabled: childProps.isSubmitting
        }, children);
      }

      var fieldProps = {
        touched: childProps.touched[fieldName],
        error: childProps.errors[fieldName],
        value: childProps.values[fieldName],
        displayRequiredIndicator: displayRequiredIndicator
      };
      return /*#__PURE__*/React.cloneElement(child, _objectSpread({}, childProps, {}, fieldProps), null);
    }));
  });
};

FormikWrapper.defaultProps = {
  onSubmit: function onSubmit() {},
  initialValues: {},
  displayRequiredIndicator: "optional",
  validate: function validate() {},
  validateOnChange: true,
  validateOnBlur: true,
  validateOnMount: false,
  onReset: function onReset() {}
};
FormikWrapper.propTypes = {
  onSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  displayRequiredIndicator: PropTypes.oneOf(['optional', 'required', 'none']),
  validate: PropTypes.func,
  validateOnChange: PropTypes.bool,
  validateOnBlur: PropTypes.bool,
  validateOnMount: PropTypes.bool,
  onReset: PropTypes.func
};
export default FormikWrapper;